import { html, render, nothing } from "lit-html";
import { IDetailedCartInfo } from "../../interfaces/detailed-cart-info.js";
import { SummaryCartInfoContract } from "../../interfaces/summary-cart-info-contract.js";
import { SiteCartController } from "../../site-cart-controller.js";
import { Locale } from "../../../../common/interfaces/locate.js";
import { determineTranslation } from "../../../../utils/language.js";
import { cartEventSubscriber } from "../../../../common/pubsub/cart-event-pub-sub.js";
//The Vipps checkout button was not defined by BA+Desinger to be used in sitecart sidebar! Don't add it here!
export class CartSidebarTotalSummary extends HTMLElement {
    constructor() {
        super();
    }

    /* #region Translations */
    private translations: ITranslationSet = {
        [Locale.En]:{
            incVat: "Inc. TVA",
            excVat: "Exc. TVA",
            totalDiscount: "Total discount",
            totalSum: "Total sum",
        },
        [Locale.No]: {
            incVat: "Inkl. MVA",
            excVat: "Eks. MVA",
            totalDiscount: "Total rabatt",
            totalSum: "Total sum",
        }
    };
    private labels = determineTranslation(this.translations) as ISiteCartSidebarLabels;
    /* #endregion */

    /* #region Markup */
    private template = () => html`
        <table width="100%" class="total-summary">
            ${this._summary.totalDiscount ? html `
            <tr class="total-discount ${CssClasses.FontSizeSmall}">
                <td>${this.labels.totalDiscount}:</td>
                <td align="right">${this._summary.formattedTotalDiscount}</td>
            </tr>
            ` : nothing }
            <tr class="total-sum ${CssClasses.SemiboldFont}">
                <td>${this.labels.totalSum} (${this._vatLabel()}):</td>
                <td align="right">${this._orderSumAmount(this._summary)}</td>
            </tr>
        </table>
    `;
    /* #endregion */

    /* #region Private */
    private _inclVat: boolean = window.globalSettings.displayPricesIncludingVat;
    private _siteCartController = new SiteCartController();
    private _summary: SummaryCartInfoContract;

    private _vatLabel(){
        return this._inclVat ? this.labels.incVat : this.labels.excVat;
    }

    private _orderSumAmount(data: SummaryCartInfoContract){
        return this._inclVat ? data.formattedTotalPrice : data.formattedTotalPriceExclVat;
    }

    private async _updateView(){
        render(this.template(), this);
    }

    private async _onSiteCartChanged(topic: string, data: IDetailedCartInfo){
        this._summary = data.summary;
        this._updateView();
    }
    /* #endregion */

    public connectedCallback() {
        if(this.isConnected){
            this._summary = this._siteCartController.getSiteCartInfo().summary;
            this._updateView();
            cartEventSubscriber.onSiteCartChanged(this._onSiteCartChanged.bind(this));
        }
    }
}

customElements.define('cart-sidebar-total-summary', CartSidebarTotalSummary);

/* #region Local interfaces */
interface ISiteCartSidebarLabels{
    incVat: string;
    excVat: string;
    totalDiscount: string;
    totalSum: string;
}

interface ITranslationSet {
    [key:string]: ISiteCartSidebarLabels
}

enum CssClasses {
    SemiboldFont = 'fw-semibold',
    HiddenTrBottomBorder = 'border-bottom-none',
    FontSizeSmall = 'fs-sm',
    TextGrayColor = 'text-secondary'
}
/* #endregion */